export const TaskBeltStatuses = {
    Available: 'available',
    Break: 'break',
    Monitoring: 'monitoring',
    Busy: 'busy',
    Unknown: 'unknown',
} as const;

export type TaskBeltStatus =
    (typeof TaskBeltStatuses)[keyof typeof TaskBeltStatuses];
